
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Index from "./pages/Index";
import Admin from "./pages/Admin";
import AdminMessages from "./pages/AdminMessages";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import SeoPage from "./pages/SeoPage";
import ProviderPage from "./pages/ProviderPage";
import AllProvidersPage from "./pages/AllProvidersPage";
import { useEffect } from "react";
import { ensureStorageBuckets } from "./utils/setupStorage";

import "./App.css";

// ScrollToTop component that handles scrolling on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  useEffect(() => {
    // Set up storage buckets when the app loads
    ensureStorageBuckets();
  }, []);
  
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/messages" element={<AdminMessages />} />
        
        {/* New Danish routes */}
        <Route path="/om-os" element={<About />} />
        <Route path="/kontakt" element={<Contact />} />
        <Route path="/privatlivspolitik" element={<Privacy />} />
        <Route path="/mobiludbyder/:providerSlug" element={<ProviderPage />} />
        <Route path="/mobiludbydere" element={<AllProvidersPage />} />
        
        {/* Redirects from old routes */}
        <Route path="/about" element={<Navigate to="/om-os" replace />} />
        <Route path="/contact" element={<Navigate to="/kontakt" replace />} />
        <Route path="/privacy" element={<Navigate to="/privatlivspolitik" replace />} />
        <Route path="/provider/:providerSlug" element={<ProviderRedirect />} />
        <Route path="/udbyder/:providerSlug" element={<MobileProviderRedirect />} />
        
        <Route path="/login" element={<Login />} />
        <Route path="/:slug" element={<SeoPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

// Helper component to handle dynamic provider redirects from old English routes
function ProviderRedirect() {
  const location = window.location.pathname;
  const providerSlug = location.split('/provider/')[1];
  const redirectTo = `/mobiludbyder/${providerSlug}`;
  
  return <Navigate to={redirectTo} replace />;
}

// Helper component to handle redirects from /udbyder to /mobiludbyder
function MobileProviderRedirect() {
  const location = window.location.pathname;
  const providerSlug = location.split('/udbyder/')[1];
  const redirectTo = `/mobiludbyder/${providerSlug}`;
  
  return <Navigate to={redirectTo} replace />;
}

export default App;
